

















import { Component, Vue, Watch } from 'vue-property-decorator';
import AppMenu from '@/components/appMenu.vue';
import AppBreadcrumb from '@/components/breadcrumb.vue';
import AppNavbar from '@/components/app-navbar.vue';

@Component({
  name: 'defaultLayout',
  components: { AppNavbar, AppBreadcrumb, AppMenu },
})
export default class DefaultLayout extends Vue {
  // get breadcrumb() {
  //   return this.$route.meta;
  // }
}
